import { ChannelIcon, EmptyState, Flex, Heading } from '@buffer-mono/popcorn'

import styles from './ChannelNeedsRefresh.module.css'
import type { ChannelType } from '~publish/pages/Comments/types'
import { getTooltipContent } from '../CommentsSidebar/ChannelNav/helpers'

export function ChannelNotAvailable({
  channel,
}: {
  channel: ChannelType
}): JSX.Element {
  return (
    <EmptyState size="xlarge" variant="primary" className={styles.emptyState}>
      <EmptyState.Icon>
        <ChannelIcon type={channel.service} color="branded" />
      </EmptyState.Icon>
      <EmptyState.Heading className={styles.header}>
        <Flex direction="column" gap="2xs" align="center">
          <Heading as="h2">
            {getTooltipContent(channel.service, channel.type)}
          </Heading>
        </Flex>
      </EmptyState.Heading>
    </EmptyState>
  )
}
